export default __webpack_public_path__ + "static/media/p20.f9ea9296.jpg";